import { Button, Dialog } from '@risksmart-app/atomic-ui';
import { useTranslation } from 'react-i18next';

interface ConflictDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onReload: () => void;
}

export const ConflictDialog = ({
  open,
  onOpenChange,
  onReload,
}: ConflictDialogProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'riskScoringSettings',
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange} size={'md'}>
      <Dialog.Header title={t('conflict.dialogTitle')} />
      <Dialog.Body>{t('conflict.dialogDescription')}</Dialog.Body>
      <Dialog.Footer>
        <Button onClick={onReload}>{t('conflict.button')}</Button>
        <Dialog.Close
          render={
            <Button variant={'neutral'} style={'outline'}>
              {t('cancel')}
            </Button>
          }
        />
      </Dialog.Footer>
    </Dialog>
  );
};
